const UNITS: Record<string, number> = {
  ms: 1,
  s: 1000,
  m: 60 * 1000,
  h: 60 * 60 * 1000,
  d: 24 * 60 * 60 * 1000,
  w: 7 * 24 * 60 * 60 * 1000,
};

/** Parse a duration string like "5m", "30s", "2h", "1d" into milliseconds. */
export function parseDuration(str: string): number {
  const m = /^(\d+)\s*(ms|s|m|h|d|w)$/.exec(str.trim());
  if (!m) throw new Error(`Invalid duration: ${str}`);
  const n = parseInt(m[1]!, 10);
  const unit = m[2]!;
  return n * UNITS[unit]!;
}

/** "now", "5m", "2h", "3d" — relative to now. */
export function formatRelativeTime(t: number, now = Date.now()): string {
  const diff = now - t;
  const abs = Math.abs(diff);
  if (abs < 60_000) return 'now';
  if (abs < 3600_000) return `${Math.floor(abs / 60_000)}m`;
  if (abs < 86_400_000) return `${Math.floor(abs / 3600_000)}h`;
  return `${Math.floor(abs / 86_400_000)}d`;
}

/** UTC clock as HH:MM:SS for the HUDBar. */
export function utcClock(t = Date.now()): string {
  const d = new Date(t);
  const pad = (n: number) => n.toString().padStart(2, '0');
  return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
}
